/**
 * Badges shown on a task/assignment card and in the task detail. Kept here so
 * the three overview cards and the status bar render the same label and color.
 */
export const TASK_TAG_BADGE_COLOR = "portfolio-tag";

export const TASK_REQUIRED_BADGE = {
  name: "Verplicht",
  color: "negative",
} as const;

export const TASK_ASSESSABLE_BADGE = {
  name: "Beoordeling",
  color: "info",
} as const;
